import { TextInputWithLabel } from '@/src/common/components/elements/Forms/TextInputWithLabel'
import { inputHasError } from '@/src/common/utilities/inputHasError'
import { BaseSyntheticEvent, useEffect, useState } from 'react'
import { FormErrorDisplay } from '../../build-a-card/FormErrorDisplay'
import { IDeliveryStreetAddress } from '../../cart/ICart'
import { ShippingFormContainer } from '../ShippingStep/ShippingStepStyles'
import DeliveryMethodSelect from '../content/DeliveryMethodSelect'
import AddressForm from '../forms/AddressForm'
import { FieldWrapper } from '@/src/common/components/elements/Forms/StyledComponents'

export default function ShippingForm({
    shippingAddress = {
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        name: '',
    },
    deliveryOptions = [],
    selectedDeliveryOption = '',
    allowUsps = true,
    formErrors = [],
    onChange = () => {},
    setIsMultipleShipments,
    hasOnlyBoxes,
}: {
    shippingAddress?: IDeliveryStreetAddress
    deliveryOptions?: any[]
    selectedDeliveryOption?: string
    allowUsps?: boolean
    formErrors?: any[]
    onChange: ({
        name,
        address,
        deliveryMethodUuid,
    }: {
        name: string
        address: IDeliveryStreetAddress
        deliveryMethodUuid: string
    }) => any
    setIsMultipleShipments: Function
    hasOnlyBoxes: boolean
}) {
    const [name, setName] = useState<string>(shippingAddress?.name ?? '')
    const [address, setAddress] =
        useState<IDeliveryStreetAddress>(shippingAddress)
    const [deliveryMethodUuid, setDeliveryMethodUuid] = useState<string>(
        selectedDeliveryOption
    )

    useEffect(() => {
        if (!shippingAddress.address1) {
            if (address?.address1 || name) {
                onChange({ name, address, deliveryMethodUuid })
            }
            return
        }
        setName(name ?? shippingAddress?.name)
        setAddress(address ?? shippingAddress)
        setDeliveryMethodUuid(selectedDeliveryOption ?? deliveryMethodUuid)
    }, [shippingAddress])

    return (
        <ShippingFormContainer>
            <FieldWrapper>
                <TextInputWithLabel
                    value={name}
                    placeholder={'Name'}
                    onChange={(e: BaseSyntheticEvent) => {
                        setName(e.target.value)
                        onChange({
                            name: e.target.value,
                            address,
                            deliveryMethodUuid,
                        })
                    }}
                    hasError={inputHasError(formErrors, 'name')}
                />
                <FormErrorDisplay formErrors={formErrors} path={'name'} />
            </FieldWrapper>
            <AddressForm
                value={address}
                formErrors={formErrors}
                onChange={(address: IDeliveryStreetAddress) => {
                    setDeliveryMethodUuid('')
                    setAddress(address)
                    onChange({ name, address, deliveryMethodUuid: '' })
                }}
            />
            <DeliveryMethodSelect
                address={address}
                options={deliveryOptions}
                selectedOption={deliveryMethodUuid ?? selectedDeliveryOption}
                allowUsps={allowUsps}
                allowFedex={address?.state === 'AA' ? false : true}
                formErrors={formErrors}
                onChange={(deliveryMethodUuid: string) => {
                    setDeliveryMethodUuid(deliveryMethodUuid)
                    onChange({ name, address, deliveryMethodUuid })
                }}
                setIsMultipleShipments={setIsMultipleShipments}
                clearAddress={() => {
                    setAddress({
                        address1: '',
                        address2: '',
                        city: '',
                        state: '',
                        zip: '',
                    })
                }}
                hasOnlyBoxes={hasOnlyBoxes}
            />
        </ShippingFormContainer>
    )
}
